import { Reveal } from "@/components/Reveal";
import { ABOUT } from "@/data";

export const About = () => (
  <section id="pozvanka" className="py-20 md:py-28">
    <div className="mx-auto max-w-3xl px-6">
      <Reveal>
        <p className="mb-6 text-xs font-semibold uppercase tracking-[0.22em] text-[var(--accent)]">
          {ABOUT.eyebrow}
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <p
          data-testid="about-text"
          className="font-display text-2xl/[1.65] sm:text-3xl/[1.65] md:text-[2.1rem]/[1.65] font-medium text-[var(--ink)]"
        >
          {ABOUT.parts.map((p, i) =>
            p.hl ? (
              <span key={i} className="text-highlight text-[var(--forest-dark)]">
                {p.text}
              </span>
            ) : (
              <span key={i}>{p.text}</span>
            )
          )}
        </p>
      </Reveal>
    </div>
  </section>
);
